import api from './api';

export const getCurrencyRates = async (params = {}) => {
  const res = await api.get('/admin/currency-rate/', { params });
  return res.data;
};

export const createCurrencyRate = async (data) => {
  const res = await api.post('/admin/currency-rate/', data);
  return res.data;
};

export const updateCurrencyRate = async (id, data) => {
  const res = await api.put(`/admin/currency-rate/${id}/`, data);
  return res.data;
};

export const deleteCurrencyRate = async (id) => {
  const res = await api.delete(`/admin/currency-rate/${id}/`);
  return res.data;
}; 
